import { getDownloadHeadersWithCurrentAccountConsumerId } from 'lib/downloads/utils';
import { Dispatch } from 'redux';
import FileServices from 'services/FileServices';
import { medicalHistoryDownloadingSelector } from 'store/medicalHistory/selectors';
import { messageQuestion, messageShare } from 'store/messaging/actions';
import { currentConsumerPcpDoctorsSelector } from 'store/myDoctors/selectors';
import { RootState, Thunk } from 'store/types';
import { oc } from 'ts-optchain';
import { DFDHeaders } from 'serverTypes/authentication';
import { DFDHeadersObject, DispatcherResource, DispatcherEndpoint } from 'modules/types/common';
import { TransmitSources } from '../transmit';
import { MedicalHistoryData } from './types';
import { getMedicalHistoryEndpointGenerator } from './common';

const getEndpoint = getMedicalHistoryEndpointGenerator(DispatcherResource.MEDICAL_HISTORY);

interface MedicalHistoryQuestionProps {
  medHistory: MedicalHistoryData;
  subject?: string;
  onSendSuccess?: () => void;
}

export const askMedicalHistoryQuestion = (
  props: MedicalHistoryQuestionProps,
  isShare = false,
  returnBackTo?: string
): Thunk => (dispatch, getState) => {
  const consumerPcpList = currentConsumerPcpDoctorsSelector(getState());

  const messageParams = {
    subject: props.subject,
    onSendSuccess: props.onSendSuccess,
    transmitParams: {
      source: TransmitSources.MedicalHistory,
      payload: props.medHistory,
      returnBackTo
    }
  };

  if (isShare) {
    dispatch(messageShare(messageParams));
  } else {
    dispatch(messageQuestion(messageParams, oc(consumerPcpList)[0].cernerPersonnelId('')));
  }
};

export const SHARE_MEDICAL_HISTORY = 'MEDICAL_HISTORY.SHARE_MEDICAL_HISTORY';
export const SHARE_MEDICAL_HISTORY_SUCCESS = 'MEDICAL_HISTORY.SHARE_MEDICAL_HISTORY_SUCCESS';
export const SHARE_MEDICAL_HISTORY_FAIL = 'MEDICAL_HISTORY.SHARE_MEDICAL_HISTORY_FAIL';

export const shareMedicalHistory = (
  medHistory: any,
  toAddress: string,
  message: string,
  useSecureEmail: boolean,
  contactPhoneNumber: string,
  subject: string
) => ({
  type: SHARE_MEDICAL_HISTORY,
  payload: {
    client: 'dispatcher',
    request: {
      method: 'post',
      url: getEndpoint(DispatcherEndpoint.TRANSMIT),
      data: {
        toAddress,
        message,
        useSecureEmail,
        contactPhoneNumber,
        subject
      }
    }
  }
});

export const DOWNLOAD_MEDICAL_HISTORY = 'MEDICAL_HISTORY.DOWNLOAD_SOCIAL_HISTORY';
export const DOWNLOAD_MEDICAL_HISTORY_SUCCESS = 'MEDICAL_HISTORY.DOWNLOAD_MEDICAL_HISTORY_SUCCESS';
export const DOWNLOAD_MEDICAL_HISTORY_FAIL = 'MEDICAL_HISTORY.DOWNLOAD_MEDICAL_HISTORY_FAIL';

export const downloadMedicalHistory = () => async (
  dispatch: Dispatch,
  getState: () => RootState
) => {
  const state = getState();

  if (medicalHistoryDownloadingSelector(state) === true) {
    return;
  }

  dispatch({ type: DOWNLOAD_MEDICAL_HISTORY, payload: {} });

  const timestamp = Date.now();

  try {
    const uri = getEndpoint(DispatcherEndpoint.DOWNLOAD, true);

    const headers: DFDHeadersObject = {
      [DFDHeaders.accept]: 'application/pdf',
      ...getDownloadHeadersWithCurrentAccountConsumerId(state, uri)
    };
    const response = await FileServices.download(`medical-history-${timestamp}.pdf`, uri, headers);

    dispatch({ type: DOWNLOAD_MEDICAL_HISTORY_SUCCESS, payload: { response } });
  } catch (err) {
    dispatch({ type: DOWNLOAD_MEDICAL_HISTORY_FAIL, error: err });
  }
};
